<template>
  <section class="register-kid">
    <div class="register-kid__container">
      <div class="register-kid__container__header" id="checkout-dados-da-criança-titulo">
        <h1
          v-if="form.show && !form.edit && this.kidList.length"
          section-title v-html="$t('checkout.registerKid.form.title')"></h1>
        <h1
          v-else
          section-title v-html="$t('checkout.registerKid.title')"></h1>

        <p
          v-if="form.show && !form.edit && this.kidList.length"
          v-html="$t('checkout.registerKid.form.description')"></p>
        <p
          v-else
          v-html="$t('checkout.registerKid.description')"></p>
      </div>
      <transition name="fade" mode="out-in">
        <form v-if="form.show" class="register-kid__container__form" @submit.prevent="submit" novalidate autocomplete="off">
          <div id="checkout-dados-da-criança-titulo" class="register-kid__container__form__body">
            <div class="register-kid__container__form__body__input-group">
              <pk-input v-model="name"
                :placeholder="$t('checkout.registerKid.form.inputName')"
                type="text" ref="kidName"
                :error="$v.name.$error"
              />
            </div>
            <div class="register-kid__container__form__body__input-group">
              <pk-input
                v-model="birthDate"
                :placeholder="$t('checkout.registerKid.form.inputBirthDate')"
                :error="$v.birthDate.$error"
                mask="##/##/####" type="text" ref="kidBirthDate" />
            </div>
            <div class="register-kid__container__form__body__buttons">
              <btn
                v-if="this.kidList.length"
                class="register-kid__container__form__body__buttons__button"
                color="white"
                @click="cancelFormKidProfile"
              >{{ $t('checkout.registerKid.form.cancelButtonLabel') }}</btn>
              <btn
                v-if="form.edit"
                class="register-kid__container__form__body__buttons__button"
                color="purple"
                @click="updateKidProfile"
                :loading="form.processing"
              >{{ $t('checkout.registerKid.form.updateButtonLabel') }}</btn>
              <btn
                v-else
                class="register-kid__container__form__body__buttons__button"
                color="purple"
                @click="registerKidProfile"
                :loading="form.processing"
                id="checkout-dados-da-criança-cta-criar-perfil"
              >{{ $t('checkout.registerKid.form.saveButtonLabel') }}</btn>
            </div>
          </div>
        </form>

        <div v-else class="register-kid__container__list">
          <transition-group tag="div" class="register-kid__container__list__slider" name="slide">
            <div
              class="register-kid__container__list__card"
              :class="selectedKidSlidePosition"
              v-for="kid in [selectedKid]" :key="`kid-${kid.name}`"
            >
              <div class="register-kid__container__list__card__content">
                <div class="register-kid__container__list__card__content__property">
                  <label>{{ $t('checkout.registerKid.list.card.name') }}</label>
                  <span>{{ kid.name }}</span>
                </div>
                <div class="register-kid__container__list__card__content__property">
                  <label>{{ $t('checkout.registerKid.list.card.birthDate') }}</label>
                  <span>{{ kid.birthDate }}</span>
                </div>
                <a class="register-kid__container__list__card__content__edit-button" @click="editKidProfile()">
                  <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12.0376 3.53566L0.723891 14.8494L0.478981 17.5434C0.422441 18.1653 0.943474 18.6863 1.56541 18.6298L4.25943 18.3849L15.5731 7.07119L12.0376 3.53566Z" fill="#A217AB"/>
                    <path d="M16.2802 6.36409L18.4016 4.24275C18.7921 3.85223 18.7921 3.21906 18.4016 2.82854L16.2802 0.707216C15.8897 0.316692 15.2566 0.316692 14.866 0.707216L12.7447 2.82855L16.2802 6.36409Z" fill="#A217AB"/>
                  </svg>
                  {{ $t('checkout.registerKid.list.card.editButton') }}
                </a>
                <a class="register-kid__container__list__card__content__remove-button" @click="confirmRemoveKidProfile()">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M15.5 4H18C18.55 4 19 4.45 19 5C19 5.55 18.55 6 18 6H6C5.45 6 5 5.55 5 5C5 4.45 5.45 4 6 4H8.5L9.21 3.29C9.39 3.11 9.65 3 9.91 3H14.09C14.35 3 14.61 3.11 14.79 3.29L15.5 4ZM8 21C6.9 21 6 20.1 6 19V9C6 7.9 6.9 7 8 7H16C17.1 7 18 7.9 18 9V19C18 20.1 17.1 21 16 21H8Z" fill="#A217AB"/>
                  </svg>
                </a>
              </div>
            </div>
          </transition-group>
          <nav class="register-kid__container__list__nav" v-if="kidList.length > 1">
            <li :key="'kid-item-' + i" class="register-kid__container__list__nav__item" v-for="(kid, i) in kidList"
              :class="isSelected(i) ? 'register-kid__container__list__nav__item--selected' : ''"
              @click="selectKidProfile(i)"
            ></li>
          </nav>
          <btn
            v-if="kidList.length < 4"
            class="register-kid__container__list__button"
            color="purple"
            @click="newKidProfile"
          >{{ $t('checkout.registerKid.list.buttonLabel') }}</btn>
        </div>
      </transition>
    </div>
    <ModalSlotted @close="cancelRemoveKidProfile" v-if="removeModal.show">
      <div class="register-kid__remove-modal" slot="body">
        <div class="register-kid__remove-modal__form">
          <h2>
            {{ $t('checkout.registerKid.removeModal.title') }} {{ selectedKid.name }}?
          </h2>
          <div class="register-kid__remove-modal__form__buttons">
            <btn
              color="white"
              @click="cancelRemoveKidProfile"
            >{{ $t('checkout.registerKid.removeModal.cancelButton') }}</btn>
            <btn
              color="purple"
              @click="removeKidProfile"
              :loading="form.processing"
            >{{ $t('checkout.registerKid.removeModal.removeButton') }}</btn>
          </div>
        </div>
        <div class="register-kid__remove-modal__kim-container">
          <kim-modal-icon class="register-kid__remove-modal__container__kim-container__kim-icon" />
          <svg class="register-kid__remove-modal__kim-container__close-icon" @click="cancelRemoveKidProfile" width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="56" height="56" rx="28" fill="#A217AB"/>
            <path d="M34.8711 31.9357C35.2091 32.3197 35.378 32.7421 35.378 33.2029C35.378 33.7251 35.1707 34.1859 34.7559 34.5853C34.3566 34.9693 33.9035 35.1613 33.3966 35.1613C32.859 35.1613 32.3905 34.9309 31.9911 34.4701L28.0283 29.7238L23.9963 34.4701C23.5969 34.9309 23.1361 35.1613 22.6139 35.1613C22.107 35.1613 21.6462 34.9616 21.2315 34.5622C20.8321 34.1629 20.6324 33.7021 20.6324 33.1798C20.6324 32.7344 20.7937 32.3197 21.1163 31.9357L25.5399 26.8208L21.2315 21.8211C20.8935 21.4218 20.7246 21.007 20.7246 20.577C20.7246 20.0547 20.9243 19.6016 21.3236 19.2176C21.7383 18.8182 22.2068 18.6186 22.7291 18.6186C23.2667 18.6186 23.7351 18.849 24.1345 19.3098L28.0283 23.9178L31.899 19.3098C32.2676 18.849 32.7207 18.6186 33.2583 18.6186C33.7806 18.6186 34.2414 18.8182 34.6407 19.2176C35.0555 19.6016 35.2628 20.0547 35.2628 20.577C35.2628 21.0224 35.1015 21.4371 34.779 21.8211L30.4705 26.8208L34.8711 31.9357Z" fill="white"/>
          </svg>
        </div>
      </div>
    </ModalSlotted>
    <kim-icon class="register-kid__icon" />
  </section>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import validatorMixin from '@/js/mixins/validator'
import moment from 'moment'

export default {
  name: 'checkout-register-kid-step',
  mixins: [validatorMixin],
  props: {
    kidList: Array
  },
  data: () => ({
    indexSelected: 0,
    selectedKidSlidePosition: 'left',
    form: {
      show: true,
      edit: false,
      processing: false
    },
    removeModal: {
      show: false
    },
    name: '',
    birthDate: ''
  }),
  validations: {
    name: { required },
    birthDate: {
      required,
      dateValidation: function (value) {
        if (value && value.length === 8) {
          return moment(value, this.$t('common.format.dateRaw')).isValid() && moment(value, this.$t('common.format.dateRaw')).isBefore(moment())
        }
        return false
      }
    }
  },
  computed: {
    selectedKid() {
      const instance = this.kidList[this.indexSelected]
      return {
        ...instance,
        birthDate: moment(instance.birthDate, 'YYYY-MM-DD').format(this.$t('common.format.date'))
      }
    }
  },
  methods: {
    isSelected(i) {
      return (i === this.indexSelected)
    },
    selectKidProfile(i) {
      if (this.indexSelected < i) {
        this.selectedKidSlidePosition = 'left'
      } else {
        this.selectedKidSlidePosition = 'right'
      }
      this.indexSelected = i
    },
    isFormValid() {
      return !this.$v.$invalid
    },
    cancelFormKidProfile() {
      this.form.show = false
    },
    newKidProfile() {
      this.form.show = true
    },
    editKidProfile() {
      this.form = {
        show: true,
        edit: true,
        processing: false
      }
      this.name = this.kidList[this.indexSelected].name
      this.birthDate = moment(this.kidList[this.indexSelected].birthDate, 'YYYY-MM-DD').format(this.$t('common.format.dateRaw'))
    },
    finishProcessing() {
      this.form.processing = false
    },
    resetRemoveModal() {
      this.removeModal = {
        show: false
      }
    },
    resetKidProfileForm() {
      this.form = {
        show: false,
        edit: false,
        processing: false
      }
      this.name = ''
      this.birthDate = ''
      this.$v.$reset()
    },
    confirmRemoveKidProfile() {
      this.removeModal = {
        show: true
      }
    },
    cancelRemoveKidProfile() {
      this.removeModal = {
        show: false
      }
    },
    removeKidProfile() {
      const index = this.indexSelected
      this.indexSelected = 0
      this.form.processing = true
      this.$emit('removeKidProfile', { ...this.kidList[index] })
    },
    updateKidProfile() {
      if (!this.isFormValid()) {
        return
      }
      this.form.processing = true
      const newKidProfile = { id: this.kidList[this.indexSelected].id, name: this.name, birthDate: moment(this.birthDate, this.$t('common.format.dateRaw')).toDate() }
      this.$emit('updateKidProfile', newKidProfile)
    },
    registerKidProfile() {
      if (!this.isValid()) {
        return
      }
      this.form.processing = true
      const newKidProfile = { name: this.name, birthDate: moment(this.birthDate, this.$t('common.format.dateRaw')).toDate() }
      this.$emit('registerKidProfile', newKidProfile)
    }
  },
  watch: {
    kidList: function(newVal) {
      if (newVal.length) {
        this.form.show = false
      } else {
        this.form.show = true
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.register-kid {
  position: relative;
  display: flex;
  flex-grow: 1;
  margin-top: 0;
  padding-top: 9.5rem;
  min-height: 652px;

  &__container {
    display: flex;
    flex-direction: column;
    min-width: 100%;

    &__header {
      min-width: 100%;
      margin-bottom: 1rem;
      h1 {
        font-family: Nunito;
        font-style: normal;
        font-weight: 900;
        font-size: 26px;
        line-height: 32px;
        color: #443D4B;
      }
      p {
        font-family: Nunito;
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 20px;
        color: #454545;
      }
    }

    &__form {
      min-width: 100%;
      margin-top: 2rem;
      &__body {
        min-width: 100%;
        &__input-group {
          margin-bottom: 3rem;
        }
        &__buttons {
          display: flex;
          &__button {
            flex: 1;
            margin-top: 2rem;
          }
        }
      }
    }

    &__list {
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      min-width: 100%;
      padding-bottom: 2.4rem;

      &__slider{
        overflow: hidden;
        position: relative;
        width: calc(100vw - 2rem);
        max-width: 464px;
        height: 250px;
        display: flex;
        flex-direction: row;
        z-index: 1;
      }

      &__card {
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right:0;
        padding: 3rem 3rem 3.5rem 3rem;
        min-width: 100%;
        min-height: 100%;
        background-color: #F7F7F7;
        border-radius: 16px;

        &.slide-leave-active,
        &.slide-enter-active {
          transition: 1s;
        }

        &.left.slide-enter {
          transform: translate(100%, 0);
        }
        &.left.slide-leave-to {
          transform: scale(0);
        }
        &.right.slide-enter {
          transform: translate(-100%, 0);
        }
        &.right.slide-leave-to {
          transform: scale(0);
        }

        &__content {
          display: flex;
          flex-direction: column;
          margin-top: 1rem;
          &__property {
            display: flex;
            flex-direction: column;
            margin-bottom: 1rem;
            label {
              font-family: Nunito;
              font-style: normal;
              font-weight: 600;
              font-size: 16px;
              line-height: 22px;
              color: #454545;
            }
            span {
              font-family: Nunito;
              font-style: normal;
              font-weight: 600;
              font-size: 22px;
              line-height: 28px;
              color: #454545;
            }
          }
          &__edit-button {
            font-family: Nunito;
            font-style: normal;
            font-weight: 900;
            font-size: 18px;
            line-height: 24px;
            color: #A217AB;
            text-decoration: none;
            &:hover {
              text-decoration: none;
            }
          }
          &__remove-button {
            position: absolute;
            top: 1.5rem;
            right: 1.5rem;
          }
        }
      }
      &__nav {
        display: flex;
        align-items: center;
        margin-top: -25px;
        max-width: 288px;
        height: 45px;
        background: #FFFFFF;
        border-radius: 35px;
        box-shadow: 0px 4px 18px rgba(0, 0, 0, 0.1);
        padding-left: 1rem;
        padding-right: 1rem;
        z-index: 2;

        &__item {
          list-style: none;
          width: 20px;
          height: 20px;
          border: 3px solid #A217AB;
          box-sizing: border-box;
          border-radius: 10px;
          margin-left: .4rem;
          margin-right: .4rem;

          &--selected {
            padding-left: 2.5rem;
            padding-right: 2.5rem;
            background: #6253BC;
            border: none;
            border-radius: 16px;
          }
        }
      }
      &__button {
        min-width: 100%;
        margin-top: 3rem;
      }
    }
  }

  &__icon {
    position: absolute;
    display: none;
    right: 0;
    width: 448px;
    height: 662px;
  }
  &__remove-modal {
    display: flex;
    justify-content: space-between;

    &__form {
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding-left: 2rem;
      padding-right: 2rem;
      width: 100%;
      height: 200px;

      h2 {
        font-family: Nunito;
        font-style: normal;
        font-weight: 900;
        font-size: 20px;
        line-height: 28px;
        color: #443D4B;
      }

      &__buttons {
        display: flex;
        justify-content: space-evenly;
        margin-top: 1rem;
        button {
          min-width: 150px;
        }
      }
    }
    &__kim-container {
      display: none;
      width: 80px;
      background-color: #FFFFFF;
      border-top-right-radius: 16px;
      border-bottom-right-radius: 16px;

      &__kim-icon {
        display: none;
        border-top-right-radius: 16px;
        border-bottom-right-radius: 16px;
        margin-bottom: -4px;
      }
      &__close-icon {
        position: absolute;
        top: .75rem;
        right: .75rem;
        width: 30px;
      }
    }
  }
}
@media screen and (min-width: 641px) {
  .register-kid {
    padding-top: 10rem;
    min-height: 654px;

    &__container {
      &__header {
        min-width: 600px;
        max-width: 600px;
        h1 {
          font-size: 34px;
          line-height: 34px;
        }
        p {
          font-size: 16px;
          line-height: 20px;
        }
      }
      &__form {
        &__body {
          min-width: 464px;
          max-width: 464px;
        }
      }
      &__list {
        min-width: 464px;
        max-width: 464px;

        &__card {
          &__content {
            &__property {
              label {
                font-size: 18px;
                line-height: 24px;
              }
              span {
                font-size: 24px;
                line-height: 30px;
              }
              &__edit-button {
                font-size: 24px;
                line-height: 30px;
              }
            }
          }
        }
        &__button {
          min-width: 100%;
          margin-top: 3rem;
        }
      }
    }
    &__remove-modal {
      max-width: 600px;
      width: 600px;

      &__form {
        height: 300px;
        padding-left: 4rem;
        padding-right: 4rem;
        h2 {
          font-size: 22px;
          line-height: 30px;
        }
        &__buttons {
          button {
            min-width: 200px;
          }
        }
      }
    }
  }
}
@media screen and (min-width: 769px) {
  .register-kid {
    flex-direction: row;
    padding-top: 10rem;
    min-height: 770px;

    &__container {
      min-width: 650px;
      max-width: 650px;

      &__header {
        h1 {
          font-size: 39.81px;
          line-height: 40px;
        }
        p {
          font-size: 19.2px;
          line-height: 24px;
        }
      }

      &__list {
        &__slider{
          height: 296px;
        }

        &__card {
          &__content {
            &__property {
              margin-top: .8rem;
              label {
                font-size: 20px;
                line-height: 26px;
              }
              span {
                font-size: 24px;
                line-height: 30px;
              }
              &__edit-button {
                font-size: 24px;
                line-height: 30px;
              }
            }
          }
        }
        &__button {
          min-width: 100%;
          margin-top: 3rem;
        }
      }
    }
    &__icon {
      display: block;
      right: -2rem;
    }
    &__remove-modal {
      max-width: 1024px;
      width: 1024px;

      &__form {
        height: 440px;
        h2 {
          font-size: 27.65px;
          line-height: 32px;
        }
      }
      &__kim-container {
        display: block;
        width: 400px;
        background-color: #26c2f2;
        &__kim-icon {
          display: block;
        }
        &__close-icon {
          width: 56px;
        }
      }
    }
  }
}
@media screen and (min-width: 1281px) {
  .register-kid {
    flex-direction: row;
    padding-top: 5rem;
    min-height: 778px;

    &__container {
      padding-top: 2.5rem;
      &__header {
        margin-bottom: 4rem;
      }
      &__form {
        margin-top: 2rem;
        &__body {
          &__input-group {
            margin-bottom: 4rem;
          }
          &__button {
            margin-top: 5rem;
          }
        }
      }
      &__list {
        &__card {
          &__content {
            &__property {
              label {
                font-size: 19.2px;
                line-height: 24px;
              }
              span {
                font-size: 27.65px;
                line-height: 38px;
              }
            }
          }
        }
      }
    }
    &__icon {
      top: .5rem;
      width: 476px;
      height: 976px;
    }
  }
}
</style>
